import axios from 'axios';
import Parse from 'parse';

const SESSION_HEADER = 'X-Parse-Session-Token';
const API_URL = process.env.REACT_APP_API_URL;
const ABSOLUTE_URL = /^([a-z][a-z\d+.-]*:)?\/\//i;

const getSessionToken = () => {
    const establishedToken = window.localStorage.getItem('token');
    if (establishedToken) return establishedToken;
    const currentUser = Parse.User.current();
    return currentUser ? currentUser.getSessionToken() : null;
};

const stripSessionHeaders = headers => {
    Object.keys(headers).forEach(key => {
        if (key.toLowerCase() === SESSION_HEADER.toLowerCase()) {
            delete headers[key];
        } else if (headers[key] && typeof headers[key] === 'object') {
            stripSessionHeaders(headers[key]);
        }
    });
};

export const createApiClient = (apiUrl = API_URL) => {
    const client = axios.create({ baseURL: apiUrl });
    const browserUrl = window.location.href;
    const api = apiUrl ? new URL(apiUrl, browserUrl) : null;

    client.interceptors.request.use(config => {
        config.headers = config.headers || {};
        // This instance must never forward session credentials outside its API scope.
        stripSessionHeaders(config.headers);
        if (!api) return config;

        const requestUrl = config.url || '';
        const baseUrl = config.baseURL || '';
        const resolvedUrl = ABSOLUTE_URL.test(requestUrl)
            ? requestUrl
            : `${baseUrl.replace(/\/+$/, '')}/${requestUrl.replace(/^\/+/, '')}`;
        const target = new URL(resolvedUrl, browserUrl);
        const apiPath = api.pathname.replace(/\/+$/, '');
        const isApiRequest = target.origin === api.origin &&
            (target.pathname === apiPath || target.pathname.startsWith(`${apiPath}/`));
        if (isApiRequest) {
            const token = getSessionToken();
            if (token) config.headers[SESSION_HEADER] = token;
        }
        return config;
    });

    return client;
};

export default createApiClient();
